export default {
  talk_to_us: 'Parlaci:',
  send_us_email: "Inviaci un'email:",
  visit_website: 'Visita il nostro sito:',
  join_our_community: 'Unisciti alla nostra community per offerte esclusive e aggiornamenti!',
};
